import { render, staticRenderFns } from "./form-dpd.vue?vue&type=template&id=2c655878&"
import script from "./form-dpd.vue?vue&type=script&lang=js&"
export * from "./form-dpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-dpd.vue"
export default component.exports